
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c4Cbx", function(module, exports) {
/* date-picker.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $gxtzC = parcelRequire("gxtzC");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c0qxy = parcelRequire("c0qxy");


var $8DN9t = parcelRequire("8DN9t");


var $5TGLQ = parcelRequire("5TGLQ");


var $gdv5Z = parcelRequire("gdv5Z");


var $6T8v4 = parcelRequire("6T8v4");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");

/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $dWCFT = parcelRequire("dWCFT");

var $jqWS9 = parcelRequire("jqWS9");




var $7lMCw = parcelRequire("7lMCw");




const $85f2897621056512$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $85f2897621056512$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $jqWS9.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(parsedDate)}`;
    return newIso;
};
const $85f2897621056512$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $2oOe7.defaultDateFormat));
    return l10n.parseDate(date);
};
const $85f2897621056512$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $2oOe7.defaultDateFormat));
    const date = (0, $da71s.default)(value);
    return dateFormat ? (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $85f2897621056512$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $2oOe7.placeholderDatetime));
};


/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $3hOY6 = parcelRequire("3hOY6");

const $c26bf47b337ba3d5$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c26bf47b337ba3d5$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            showClearIndicator ? $c26bf47b337ba3d5$var$styles.calendarButtonInclusionStyles : $c26bf47b337ba3d5$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).IndicatorsContainer, {
            ...rest
        })
    });


/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $91bEl = parcelRequire("91bEl");


var $iug2J = parcelRequire("iug2J");


var $dh538 = parcelRequire("dh538");


var $hq1yX = parcelRequire("hq1yX");

function $25a48d284d5ccc39$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $da71s.default)(iso);
        return (0, $cFEpk.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $25a48d284d5ccc39$var$menuStyles = null;
const $25a48d284d5ccc39$var$menuStylesT26Shape = null; /**
                                  * This is the menu used in the select of the date picker.
                                  */ 
const $25a48d284d5ccc39$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $25a48d284d5ccc39$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs130s",
                    (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $91bEl.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};


// oxlint-disable-next-line @atlassian/no-restricted-imports






function $3a91e7335c61042e$export$77d5bc49fed7ef14(date) {
    return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)('YYYY-MM-DD'));
}
function $3a91e7335c61042e$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $3a91e7335c61042e$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}



var $cda8t = parcelRequire("cda8t");

const $cdb1236235110757$var$packageName = "platform-pkg";
const $cdb1236235110757$var$packageVersion = "0.0.0-use.local";
const $cdb1236235110757$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $cdb1236235110757$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $cdb1236235110757$var$packageName,
    packageVersion: $cdb1236235110757$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $cdb1236235110757$var$DatePicker = /*#__PURE__*/ (0, $42omo.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $42omo.useRef)(null);
    const calendarRef = (0, $42omo.useRef)(null);
    const calendarButtonRef = (0, $42omo.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $42omo.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $42omo.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $42omo.useState)(propValue || defaultValue || (0, $3a91e7335c61042e$export$77d5bc49fed7ef14)(new Date()));
    const [l10n, setL10n] = (0, $42omo.useState)((0, $5TGLQ.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $42omo.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $42omo.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $42omo.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $42omo.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$cdb1236235110757$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $5TGLQ.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $42omo.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $85f2897621056512$export$38db26406d1a1ee2)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $85f2897621056512$export$6b862160d295c8e)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $cFEpk.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $3a91e7335c61042e$export$77d5bc49fed7ef14)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $85f2897621056512$export$d38e7e283938128c)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $3a91e7335c61042e$export$ff525416014fb67d)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $3a91e7335c61042e$export$77d5bc49fed7ef14)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $42omo.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $cdb1236235110757$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $c0qxy.useId)();
    const SingleValue = (0, $cda8t.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $2oOe7.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c26bf47b337ba3d5$export$d0ffd7e649cab6f), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $25a48d284d5ccc39$export$d9b273488cd8ce6f,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #080F214A)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $3a91e7335c61042e$export$77d5bc49fed7ef14)((0, $da71s.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $85f2897621056512$export$3ae94a2503e890a1)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $c0qxy.useId)()}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $gMc0m.default)([
            $cdb1236235110757$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $85f2897621056512$export$d3f5c5e0a5023fa0)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($cdb1236235110757$var$styles.iconContainerStyles, getterValue && !hideIcon ? $cdb1236235110757$var$styles.iconSpacingWithClearButtonStyles : $cdb1236235110757$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $cdb1236235110757$export$2e2bcd8739ae039 = $cdb1236235110757$var$DatePicker;
module.exports["default"] = $cdb1236235110757$export$2e2bcd8739ae039;

});

parcelRegister("2oOe7", function(module, exports) {
/**
 * This component is used to hide portions of Select component.
 */ const $65b9c14f421da27f$export$5e30e9a24d6c1203 = ()=>null;
const $65b9c14f421da27f$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $65b9c14f421da27f$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $65b9c14f421da27f$export$9e6d8fcf62256b85 = 'h:mma';
const $65b9c14f421da27f$export$75032c84f56650eb = 'YYYY/MM/DD';
function $65b9c14f421da27f$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $65b9c14f421da27f$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}
module.exports["EmptyComponent"] = $65b9c14f421da27f$export$5e30e9a24d6c1203;
module.exports["placeholderDatetime"] = $65b9c14f421da27f$export$fff8babee5abe3e2;
module.exports["defaultTimes"] = $65b9c14f421da27f$export$b42ffb9f09b1861b;
module.exports["defaultTimeFormat"] = $65b9c14f421da27f$export$9e6d8fcf62256b85;
module.exports["defaultDateFormat"] = $65b9c14f421da27f$export$75032c84f56650eb;
module.exports["padToTwo"] = $65b9c14f421da27f$export$a7de57e5b672ccdb;
module.exports["formatDateTimeZoneIntoIso"] = $65b9c14f421da27f$export$2eeb05a2ecc2ce0a;

});

parcelRegister("jqWS9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e25e1cd73cddce6c$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e25e1cd73cddce6c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7lMCw", function(module, exports) {
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $b5826e8cf22189ea$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $b5826e8cf22189ea$var$v1tokens = Object.keys($b5826e8cf22189ea$var$tokensMap).sort().reverse();
const $b5826e8cf22189ea$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$b5826e8cf22189ea$var$v1tokens.join('|') + '|.)', 'g');
function $b5826e8cf22189ea$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($b5826e8cf22189ea$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $b5826e8cf22189ea$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}
module.exports["convertTokens"] = $b5826e8cf22189ea$export$4d5430175be73d45;

});

parcelRegister("91bEl", function(module, exports) {
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");








var $1qfLF = parcelRequire("1qfLF");





var $cO1el = parcelRequire("cO1el");


var $ey1uv = parcelRequire("ey1uv");


var $iSulU = parcelRequire("iSulU");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");




var $u9agA = parcelRequire("u9agA");

const $56c413dce376864e$var$Header = /*#__PURE__*/ (0, $42omo.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $c0qxy.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $42omo.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ey1uv))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSulU))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$56c413dce376864e$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56c413dce376864e$export$2e2bcd8739ae039 = $56c413dce376864e$var$Header;









var $6f0Oj = parcelRequire("6f0Oj");

/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");





var $dh538 = parcelRequire("dh538");


var $d8SNb = parcelRequire("d8SNb");

const $51ea448395b49484$var$dateCellSiblingStyle = null;
const $51ea448395b49484$var$dateCellTodayStyle = null;
const $51ea448395b49484$var$dateCellPrevSelectedStyle = null;
const $51ea448395b49484$var$dateCellSelectedStyle = null;
const $51ea448395b49484$var$dateCellDisabledStyle = null;
const $51ea448395b49484$var$dateCellStyles = null; // platform-dst-shape-theme-default TODO: Merge into base after rollout
const $51ea448395b49484$var$dateCellStylesT26Shape = null;
const $51ea448395b49484$var$Date = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $ee7An.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $42omo.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $gMc0m.default)([
                "_kkk2n7od _2rkofajl _11c8fhey _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk1j28 _syazi7uo _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj1v1w _10knnqa1 _1wysdkaa _irr31dpa _30l3i7uo _1di6fcek _9h8hi7uo",
                (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
                isSibling && "_syaz1rpy _30l31rpy",
                isToday && "_syaz6x5g _k48pwu06 _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk15s3 _syazazsu _30l3azsu",
                isSelected && "_bfhk15s3 _syaz6x5g _irr3ufnl _30l36x5g",
                isDisabled && "_syaz1gmx _80om13gf _irr31j28 _30l31gmx"
            ]),
            children: day
        })
    });
}));
$51ea448395b49484$var$Date.displayName = 'Date'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $51ea448395b49484$export$2e2bcd8739ae039 = $51ea448395b49484$var$Date;


/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $43425f893909ddbd$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $43425f893909ddbd$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        testId: testId,
        xcss: $43425f893909ddbd$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $43425f893909ddbd$export$2e2bcd8739ae039 = $43425f893909ddbd$var$WeekDayGrid;


const $4ba945c9b05a81e4$var$WeekDays = /*#__PURE__*/ (0, $42omo.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $43425f893909ddbd$export$2e2bcd8739ae039), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $51ea448395b49484$export$2e2bcd8739ae039), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$4ba945c9b05a81e4$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ba945c9b05a81e4$export$2e2bcd8739ae039 = $4ba945c9b05a81e4$var$WeekDays;


/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $iXCQx = parcelRequire("iXCQx");


const $a885473fdfbb1dd4$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $a885473fdfbb1dd4$var$WeekHeader = /*#__PURE__*/ (0, $42omo.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $43425f893909ddbd$export$2e2bcd8739ae039), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.100",
                xcss: $a885473fdfbb1dd4$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$a885473fdfbb1dd4$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a885473fdfbb1dd4$export$2e2bcd8739ae039 = $a885473fdfbb1dd4$var$WeekHeader;



var $6mkwk = parcelRequire("6mkwk");


var $9GKca = parcelRequire("9GKca");

function $f02dc32cc8cbca94$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}


function $ea43d7ef0e095eed$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9GKca.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $6mkwk.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $6mkwk.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $6mkwk.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $6mkwk.default)(today, ()=>today || `${thisYear}-${(0, $f02dc32cc8cbca94$export$2e2bcd8739ae039)(thisMonth)}-${(0, $f02dc32cc8cbca94$export$2e2bcd8739ae039)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $6mkwk.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $6mkwk.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}





function $dddbc69a80aa3e99$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $42omo.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $42omo.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}






var $da71s = parcelRequire("da71s");

const $9af94d164628a3a8$export$3ae905d9742bef55 = 7;
const $9af94d164628a3a8$export$c9b7c010035d60c6 = 12;



function $2e56c786f8652328$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $f02dc32cc8cbca94$export$2e2bcd8739ae039)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $f02dc32cc8cbca94$export$2e2bcd8739ae039)(date.day)}`;
}


/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
function $2bc5f72de966b731$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}


function $73a2ab129b65a12d$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $9af94d164628a3a8$export$3ae905d9742bef55) - weekStartDay + firstDay) % (0, $9af94d164628a3a8$export$3ae905d9742bef55));
    const lastDate = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $9af94d164628a3a8$export$3ae905d9742bef55);
    const lastDateOfPreviousMonth = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $9af94d164628a3a8$export$3ae905d9742bef55) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $9af94d164628a3a8$export$3ae905d9742bef55) + dateCounter : dateCounter) + firstDay) % (0, $9af94d164628a3a8$export$3ae905d9742bef55);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $9af94d164628a3a8$export$c9b7c010035d60c6) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $9af94d164628a3a8$export$c9b7c010035d60c6) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}


function $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $42omo.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $9af94d164628a3a8$export$3ae905d9742bef55) : 0;
            return (0, $73a2ab129b65a12d$export$2e2bcd8739ae039)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $9af94d164628a3a8$export$3ae905d9742bef55)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0359114b86aba571$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $42omo.useMemo)(()=>(0, $73a2ab129b65a12d$export$2e2bcd8739ae039)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $da71s.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $da71s.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $42omo.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $2e56c786f8652328$export$2e2bcd8739ae039)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $da71s.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}








const $4bae543de1d5a89e$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $9af94d164628a3a8$export$c9b7c010035d60c6)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $4bae543de1d5a89e$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $9af94d164628a3a8$export$c9b7c010035d60c6);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $4bae543de1d5a89e$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $42omo.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $2e56c786f8652328$export$2e2bcd8739ae039)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $42omo.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $9af94d164628a3a8$export$3ae905d9742bef55);
            const daysInMonth = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $9af94d164628a3a8$export$3ae905d9742bef55);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $2bc5f72de966b731$export$2e2bcd8739ae039)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}






const $9d692683ec562e03$var$arrowKeys = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
function $9d692683ec562e03$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $2e56c786f8652328$export$2e2bcd8739ae039)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $42omo.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = $9d692683ec562e03$var$arrowKeys[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}






var $5TGLQ = parcelRequire("5TGLQ");

function $8a9118030077bfb7$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $42omo.useMemo)(()=>(0, $5TGLQ.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $42omo.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $42omo.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $42omo.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}


const $d7a40ddbec5b8284$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d7a40ddbec5b8284$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d7a40ddbec5b8284$var$InnerCalendar = /*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = [], defaultSelected: defaultSelected = [], defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $ee7An.default), onChange: onChange = (0, $ee7An.default), onFocus: onFocus = (0, $ee7An.default), onSelect: onSelect = (0, $ee7An.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $ea43d7ef0e095eed$export$2e2bcd8739ae039)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $42omo.useState)(false);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $4bae543de1d5a89e$export$2e2bcd8739ae039)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $9d692683ec562e03$export$2e2bcd8739ae039)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $dddbc69a80aa3e99$export$2e2bcd8739ae039)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $8a9118030077bfb7$export$2e2bcd8739ae039)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $0359114b86aba571$export$2e2bcd8739ae039)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $c0qxy.useId)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $d7a40ddbec5b8284$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $56c413dce376864e$export$2e2bcd8739ae039 // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $a885473fdfbb1dd4$export$2e2bcd8739ae039), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $4ba945c9b05a81e4$export$2e2bcd8739ae039), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d7a40ddbec5b8284$var$Calendar = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($d7a40ddbec5b8284$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d7a40ddbec5b8284$var$Calendar.displayName = 'Calendar';
var $d7a40ddbec5b8284$export$2e2bcd8739ae039 = $d7a40ddbec5b8284$var$Calendar;
module.exports["default"] = $d7a40ddbec5b8284$export$2e2bcd8739ae039;

});

parcelRegister("ey1uv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a1ef6001ab87a1d8d52e3fa36b1ca44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a97565c2f60dd3c7$var$_react = $a97565c2f60dd3c7$var$_interopRequireDefault((parcelRequire("42omo")));

var $a97565c2f60dd3c7$var$_baseNew = $a97565c2f60dd3c7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a97565c2f60dd3c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a97565c2f60dd3c7$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $a97565c2f60dd3c7$var$_react.default.createElement($a97565c2f60dd3c7$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$a97565c2f60dd3c7$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $a97565c2f60dd3c7$var$_default = module.exports.default = $a97565c2f60dd3c7$var$ChevronDoubleLeftIcon;

});

parcelRegister("iSulU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4e628ea814f393cf264d604c04f2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbe4d081f45335f6$var$_react = $dbe4d081f45335f6$var$_interopRequireDefault((parcelRequire("42omo")));

var $dbe4d081f45335f6$var$_baseNew = $dbe4d081f45335f6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dbe4d081f45335f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbe4d081f45335f6$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $dbe4d081f45335f6$var$_react.default.createElement($dbe4d081f45335f6$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$dbe4d081f45335f6$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $dbe4d081f45335f6$var$_default = module.exports.default = $dbe4d081f45335f6$var$ChevronDoubleRightIcon;

});

parcelRegister("hq1yX", function(module, exports) {
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $SZOxu = parcelRequire("SZOxu");


var $2xusd = parcelRequire("2xusd");

var $lqsSp = parcelRequire("lqsSp");

var $cs0ez = parcelRequire("cs0ez");

function $c20f43530238761f$var$_defineProperty(e, r, t) {
    return (r = $c20f43530238761f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c20f43530238761f$var$_toPropertyKey(t) {
    var i = $c20f43530238761f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c20f43530238761f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c20f43530238761f$var$styles = {
    root: "_bfhk1j28 _kqswstnw _152tze3t",
    popperStyles: "_1pbyowjs"
};
class $c20f43530238761f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props; // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $l998X.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $SZOxu.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $l998X.jsxs)((0, $2xusd.Manager), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args);
        $c20f43530238761f$var$_defineProperty(this, "update", (0, $ee7An.default));
    }
}
module.exports["default"] = $c20f43530238761f$export$2e2bcd8739ae039;

});

parcelRegister("SZOxu", function(module, exports) {
const $0cf93e9d3df78fcc$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $0cf93e9d3df78fcc$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $0cf93e9d3df78fcc$export$62ad7b0c781000e9 = {
    small: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge
    }
};
module.exports["sizes"] = $0cf93e9d3df78fcc$export$c647cb0ee6e282fe;
module.exports["sizeMap"] = $0cf93e9d3df78fcc$export$7bd66fc94c81bf84;

});

parcelRegister("cda8t", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

const $ca1b90749f7f26ad$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };
module.exports["makeSingleValue"] = $ca1b90749f7f26ad$export$6e30bf8cb1347b56;

});


//# sourceMappingURL=modal.997e7ef2.js.map
